module.exports = __webpack_public_path__ + "img/REG_ALIM_PAI.f6b00332.svg";